
export const MIN_WIDTH = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  ['2xl']: 1536,
};
